module.exports = __webpack_public_path__ + "img/1951-Barbara_Rose_Johns.6bcf0cbb.jpg";